import type { TFunction } from "i18next";
import { WorkerEmploymentType } from "model/Salary";

interface EmploymentTypeTranslationParams {
  readonly employmentType: string | null | undefined;
  readonly translate: TFunction | ((key: string) => string);
}

const EMPLOYMENT_TYPE_TRANSLATION_KEY_BY_VALUE: Record<string, string> = {
  [WorkerEmploymentType.EMPLOYEE]: "Staff.employmentTypeEmployee",
  [WorkerEmploymentType.TEMPORARY_WORKER]:
    "Staff.employmentTypeTemporaryWorker",
  [WorkerEmploymentType.EXCLUSIVE_TEMPORARY_WORKER]:
    "Staff.employmentTypeExclusiveTemporaryWorker",
  [WorkerEmploymentType.INTRODUCTORY]: "Staff.employmentTypeIntroductory",
  [WorkerEmploymentType.PROJECT_EMPLOYEE]:
    "Staff.employmentTypeProjectEmployee",
  [WorkerEmploymentType.SIMFLEXITY_EMPLOYEE]:
    "Staff.employmentTypeSimflexityEmployee",
  [WorkerEmploymentType.CONSULTANT]: "Staff.employmentTypeConsultant",
  [WorkerEmploymentType.TRAINEE]: "Staff.employmentTypeTrainee",
};

const EMPLOYMENT_TYPE_DESCRIPTION_KEY_BY_VALUE: Record<string, string> = {
  [WorkerEmploymentType.EMPLOYEE]: "Staff.employmentTypeEmployeeDescription",
  [WorkerEmploymentType.EXCLUSIVE_TEMPORARY_WORKER]:
    "Staff.employmentTypeExclusiveTemporaryWorkerDescription",
  [WorkerEmploymentType.INTRODUCTORY]:
    "Staff.employmentTypeIntroductoryDescription",
  [WorkerEmploymentType.PROJECT_EMPLOYEE]:
    "Staff.employmentTypeProjectEmployeeDescription",
  [WorkerEmploymentType.CONSULTANT]:
    "Staff.employmentTypeConsultantDescription",
  [WorkerEmploymentType.TEMPORARY_WORKER]:
    "Staff.employmentTypeTemporaryWorkerDescription",
  [WorkerEmploymentType.SIMFLEXITY_EMPLOYEE]:
    "Staff.employmentTypeSimflexityEmployeeDescription",
  [WorkerEmploymentType.TRAINEE]: "Staff.employmentTypeTraineeDescription",
};

export function toEmploymentTypeLabel({
  employmentType,
  translate,
}: EmploymentTypeTranslationParams): string {
  if (!employmentType || employmentType === WorkerEmploymentType.UNDEFINED) {
    return "-";
  }

  const translationKey =
    EMPLOYMENT_TYPE_TRANSLATION_KEY_BY_VALUE[employmentType];
  return translationKey ? translate(translationKey) : employmentType;
}

export function toEmploymentTypeDescription({
  employmentType,
  translate,
}: EmploymentTypeTranslationParams): string {
  if (!employmentType) return "";
  const translationKey =
    EMPLOYMENT_TYPE_DESCRIPTION_KEY_BY_VALUE[employmentType];
  return translationKey ? translate(translationKey) : "";
}
